module.exports = __webpack_public_path__ + "static/how-to-protect-yourself-background-a95be04d91a254379a30e11c556b21a6.png";